/* Copyright (c) 2020 Paul Nebel */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isEqual, flatten, random } from 'lodash';
import { nanoid } from 'nanoid';

import Thumbnail from './thumbnail';

class ThumbnailCollection extends React.PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            buttonEvent,
            buttonClickedAt,
            buttonToggleState,
        } = nextProps;

        const newState = {
            ...prevState,
        };

        if ((buttonEvent === 'shuffle') && (buttonClickedAt !== prevState.buttonClickedAt)) {
            if (buttonToggleState) {
                newState.chords = prevState.shuffleChords();
            } else {
                newState.chords = prevState.defaultChords;
            }
            newState.buttonClickedAt = buttonClickedAt;
            prevState.notifyChordArraySelected(newState.chords);
        }

        if (!isEqual(prevState, newState)) {
            return newState;
        } else {
            return null;
        }
    }

    constructor(props, context) {
        super(props, context);
        const {
            style,
            chords,
            notifyChordArraySelected,
        } = props;
        this.shuffleChords = this.shuffleChords.bind(this);
        this.notifyChordArraySelected = notifyChordArraySelected.bind(this);
        this.state = {
            style,
            chords,
            defaultChords: chords,
            shuffleChords: this.shuffleChords,
            notifyChordArraySelected: this.notifyChordArraySelected,
        };
        this.props.notifyChordArraySelected(chords);
    }

    render() {
        const renderRows = () => {
            return this.state.chords.map((currentRow, rowIndex) => (
                <div
                    className='columns is-mobile is-0'
                    key={ `thumb-row-${rowIndex}` }
                >
                    { renderCols(currentRow, rowIndex) }
                </div>
            ));
        };
        const renderCols = (chordsArray, rowIndex) => {
            return chordsArray.map((chord, colIndex) => {
                const currentIndex = (rowIndex * chordsArray.length) + colIndex;
                return (
                    <div
                        className='column is-3 has-text-centered pb-1 pt-0'
                        key={ `thumb-col-${nanoid(10)}-${nanoid(10)}` }
                    >
                        <div
                            className='card is-clickable'
                            style={{ borderRadius: '.25rem' }}
                            onClick={ () => this.props.notifyChordSelected(currentIndex) }
                            key={ currentIndex }
                        >
                            <div className='card-content p-0'>
                                <Thumbnail
                                    style={ this.state.style }
                                    color={ this.state.color }
                                    chord={ chord }
                                    index={ currentIndex }
                                />
                            </div>
                        </div>
                    </div>
                );
            });
        };
        return (
            <div className='container'>
                { renderRows() }
            </div>
        );
    }

    shuffleChords() {
        let flattenedChords = flatten(this.props.chords);
        const shuffledChords = [];
        const repeat = flattenedChords.length;
        for (let i = 0; i < repeat; i = i + 1) {
            const randomIndex = random(flattenedChords.length - 1);
            const subArrayIndex = Math.floor(i / 4);
            if ((i % 4) === 0) {
                if (!shuffledChords[subArrayIndex]) {
                    shuffledChords.push([]);
                }
            }
            shuffledChords[subArrayIndex].push(flattenedChords[randomIndex]);
            flattenedChords.splice(randomIndex, 1);
        }
        return shuffledChords;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        notifyChordArraySelected: (
            chordArray,
        ) => dispatch({
            type: `CHORD_ARRAY_SELECTED`,
            chordArray,
        }),
        notifyChordSelected: (
            index,
        ) => dispatch({
            type: `CHORD_SELECTED`,
            index,
        }),
    };
};

const mapStateToProps = ({
    buttonEvent,
    buttonClickedAt,
    buttonToggleState,
}) => {
    return {
        buttonEvent,
        buttonClickedAt,
        buttonToggleState,
    };
};

ThumbnailCollection.propTypes = {
    chords: PropTypes.arrayOf(
        PropTypes.arrayOf(
            PropTypes.string,
        ),
    ).isRequired,
    playHeadIndex: PropTypes.number,
    style: PropTypes.object,
    notifyChordArraySelected: PropTypes.func.isRequired,
    notifyChordSelected: PropTypes.func.isRequired,
    shuffleChords: PropTypes.func,
    buttonEvent: PropTypes.string,
    buttonClickedAt: PropTypes.number,
    buttonToggleState: PropTypes.bool,
    chordIndex: PropTypes.number,
};

const chords = [
    [
        'C',
        'F',
        'Bb',
        'Eb',
    ],
    [
        'Ab',
        'Db',
        'Gb',
        'B',
    ],
    [
        'E',
        'A',
        'D',
        'G',
    ],
];
const style = {
    x:13,
    y:15,
    width:70,
    height:40,
    color:'black',
    font:'20px sans-serif',
    borderRadius: '3px',
};
ThumbnailCollection.defaultProps = {
    selectedIndex: 0,
    chords,
    style,
    buttonToggleState: false,
    thumbnailRefs: [],
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ThumbnailCollection);
